export const enum Header {
  /**
   * Common Gateway headers:
   * https://github.com/Home24/CommonGateway/blob/master/internal/constant/header.go#L62
   */
  DeviceOSName = 'x-h24-device-os-name',
  DeviceOSVersion = 'x-h24-device-os-version',
  DeviceBrowserName = 'x-h24-device-browser-name',
  DeviceBrowserVersion = 'x-h24-device-browser-version',
  DeviceIP = 'x-h24-device-ip',
  DeviceType = 'x-h24-device-type',
  UserLoggedInAs = 'x-h24-logged-in-as',

  // From PA-Signup (https://github.com/Home24/PageApp-Signup/blob/master/src/enums/header.ts)
  FlowId = 'x-flow-id',
  Language = 'x-h24-language',
  RedirectedFrom = 'x-h24-login-redirected-from',
  OriginalUrl = 'x-h24-original-url',
  UserAgent = 'user-agent',

  // Used in MyAccount E2E tests
  TestMyAccountView = 'x-test-myaccount-view',

  // Used in Checkout E2E tests
  TestCheckoutView = 'x-test-checkout-view',

  // Used in Cart E2E tests
  TestCartView = 'x-test-cart-view',

  // From PA-Checkout
  Accept = 'accept',
  NativeUserZipCode = 'x-native-user-zip-code',
}
